import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import {
  NET_30,
  NET_60,
  NET_45,
  NET_15,
  NET_10,
  NET_5,
  CREDIT_CARD
} from "MODULES/companies/constants";
import { CompanyName, Detail, DetailTable } from "MODULES/shared/components";
import { useActiveDemeritsColor } from "APP_ROOT/hooks";
import { Link } from "react-router-dom";
import { properCase } from "LIB/formatters/text";

export function VendorDetail({ record }) {
  const paymentTerms = record.payment_terms;
  const getColor = () => {
    if (
      [NET_30, NET_60, NET_45, NET_15, NET_10, NET_5, CREDIT_CARD].includes(
        paymentTerms
      )
    ) {
      return "#4CAF50";
    }
    return "#FF9800";
  };

  const demeritColor = useActiveDemeritsColor(record.company);

  return (
    <DetailTable className="table table-condensed">
      <Detail label="Buyer Name" value={record.buyer.full_name} />
      <Detail label="Buying Store" value={get(record, "buying_store.name")} />
      <Detail label="Vendor Code" value={get(record, "company.code")} />
      <Detail
        label="Vendor Name"
        value={<CompanyName company={record.company} />}
      />
      {record.company.demerits > 0 && (
        <tr>
          <th className="text-right">Active Demerits</th>
          <td style={{ color: demeritColor }}>{record.company.demerits}</td>
        </tr>
      )}
      <Detail label="Vendor Phone" value={get(record, "company.phone")} />
      <tr>
        <th className="text-right">Payment Terms</th>
        <td style={{ color: getColor() }}>{properCase(paymentTerms)}</td>
      </tr>
      {record.inventory && (
        <Detail
          label="Received Inventory"
          value={
            <Link to={`/inventories/${record.inventory.uuid}`}>
              {record.inventory.serial_number}
            </Link>
          }
        />
      )}
    </DetailTable>
  );
}

VendorDetail.propTypes = {
  record: PropTypes.instanceOf(Object)
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/VendorDetail/VendorDetail.jsx